export default "__VITE_ASSET__93011cd6__"